import { render, staticRenderFns } from "./FormSelect.vue?vue&type=template&id=1b484a38&scoped=true&"
import script from "./FormSelect.vue?vue&type=script&lang=js&"
export * from "./FormSelect.vue?vue&type=script&lang=js&"
import style0 from "./FormSelect.vue?vue&type=style&index=0&id=1b484a38&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b484a38",
  null
  
)

export default component.exports